import  { HANDLE_RE_AMC, RESET } from "../actions";
import moment from "moment";

const initialState = {
    startDate: moment(),
    endDate: moment().add(3, "month").add(10, "days"),
    filterType: 1,
    sort: "desc",
    jobCard: [],

    toggleTable: true,

    filter: 1,
    searchText: ""
};

const Report = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_RE_AMC : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default Report;